import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import MediaCard from "@/components/feature/MediaCard";
import MediaListItem from "@/components/feature/MediaListItem";
import SectionHeading from "@/components/feature/SectionHeading";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { allMedia, getHotMedia, getLatestMedia } from "@/lib/media";
import { bannerSlides } from "@/mocks/movies";

const HOME_TITLE = "91在线观看视频 - 高清正版影视在线播放平台";
const HOME_DESC =
  "91在线观看视频为您提供丰富的影视资源覆盖最新电影、电视剧和综艺节目，支持在线播放体验，让您随时随地轻松观看各种精彩内容。";
const HOME_KEYWORDS =
  "91在线观看视频,在线视频观看,高清免费影视,影视在线播放,最新电影,电视剧播放,在线视频平台";

export default function Home() {
  useDocumentMeta(HOME_TITLE, HOME_DESC, HOME_KEYWORDS);
  const hotMedia = getHotMedia(8);
  const latestMedia = getLatestMedia(8);

  return (
    <div>
      <HeroCarousel slides={bannerSlides} />

      <div className="mx-auto max-w-6xl px-4 py-10 md:px-8 md:py-14">
        <SectionHeading title="分类快捷入口" subtitle="按类型快速进入你想看的板块" />
        <CategoryEntries />
      </div>

      <div className="bg-background-100 py-10 md:py-14">
        <div className="mx-auto max-w-6xl px-4 md:px-8">
          <SectionHeading title="热门影视" subtitle="近期播放量最高的精彩作品" moreTo="/category/movie" />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {hotMedia.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-10 md:px-8 md:py-14">
        <SectionHeading title="最新上架" subtitle="按上线时间排序的新鲜内容" />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {latestMedia.map((item) => (
            <MediaListItem key={item.id} item={item} />
          ))}
        </div>
      </div>

      <div className="bg-primary-900 py-12 text-center md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <h2 className="text-2xl font-bold text-background-50 md:text-3xl">关于 91在线观看视频</h2>
          <p className="mt-4 text-sm leading-relaxed text-background-100/75 md:text-base">
            我们致力于打造清晰、好用、专业的影视内容聚合平台，汇集电影、电视剧、综艺等多元类型作品，
            提供便捷的浏览、搜索与筛选体验，让每一次找片都轻松愉快。
          </p>
          <div className="mt-8 grid grid-cols-3 gap-4">
            <div>
              <p className="text-2xl font-black text-accent-400 md:text-3xl">{allMedia.length}+</p>
              <p className="mt-1 text-xs text-background-100/70 md:text-sm">精选作品</p>
            </div>
            <div>
              <p className="text-2xl font-black text-accent-400 md:text-3xl">3</p>
              <p className="mt-1 text-xs text-background-100/70 md:text-sm">内容板块</p>
            </div>
            <div>
              <p className="text-2xl font-black text-accent-400 md:text-3xl">HD</p>
              <p className="mt-1 text-xs text-background-100/70 md:text-sm">高清体验</p>
            </div>
          </div>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}